/* eslint-disable react/forbid-prop-types */
import React from "react";
import PropTypes from "prop-types";

/**
 * Component that renders <input type="checkbox" /> element
 * and can be used as Widget componentClass.
 */
export default class InputCheckbox extends React.Component {
  /**
   * @param raw
   * @returns {String|undefined}
   */
  rawToFormValue = raw => {
    let value;
    if (raw === undefined) {
      value = undefined;
    } else if (raw) {
      value = "checked";
    } else {
      value = "";
    }
    return value;
  };

  render() {
    const { onChange, children, value, defaultValue, ...other } = this.props;
    return (
      <input
        {...other}
        type="checkbox"
        checked={this.rawToFormValue(value)}
        defaultChecked={this.rawToFormValue(defaultValue)}
        onChange={event => onChange(event)}
      >
        {children}
      </input>
    );
  }
}

InputCheckbox.propTypes = {
  onChange: PropTypes.func,
  children: PropTypes.node,
  value: PropTypes.any,
  defaultValue: PropTypes.any
};

InputCheckbox.defaultProps = {
  onChange: () => {}
};
